import { ApiResponse } from '@shared/models';
import { Material, MaterialDto } from '@app/store/shared/models';

export class Materials {
    items: Material[];
    total: number;

    constructor(response: ApiResponse<MaterialDto[]>) {
        this.items = response.data.map((dto) => new Material(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
